/**
 * Format a date string as "Month Day, Year at HH:MM"
 * Extracted from campaign view components where it was copy-pasted 11 times.
 */
export function dateFormat(date) {
  const notificationDate = new Date(date);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    months[notificationDate.getMonth()] +
    " " +
    notificationDate.getDate() +
    ", " +
    notificationDate.getFullYear() +
    "   at  " +
    notificationDate.getHours() +
    ":" +
    (notificationDate.getMinutes() < 10
      ? "0" + notificationDate.getMinutes()
      : notificationDate.getMinutes())
  );
}
